const stringNotationSpliter = (text) => text.split(/(\[[^\]]+\])/g);

export default stringNotationSpliter;